import { ListChecks } from "lucide-react";
import {
  CountermeasureTableParamsSchema,
  defaultCountermeasureTableParams,
  type CountermeasureTableParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { CountermeasureTableWidget } from "./Component.js";
import { CountermeasureExpandedEditor } from "./ExpandedEditor.js";

export const countermeasureTableDef: WidgetDef<CountermeasureTableParams> = {
  kind: "countermeasureTable",
  label: "Countermeasure Plan",
  modes: ["canvas"],
  singleton: true,
  defaultSize: { w: 752, h: 324 },
  defaultParams: defaultCountermeasureTableParams,
  Component: CountermeasureTableWidget,
  ExpandedComponent: CountermeasureExpandedEditor,
  storage: "sql",
  schema: CountermeasureTableParamsSchema,
  accent: "purple",
  icon: ListChecks,
  subtitle: "Tracked owners, sizing and rollout windows",
  dragLabel: "Countermeasure Table",
  defaultRoster: true,
  category: "single",
  layout: { col: "full", row: 1, width: 752, height: 300 },
  expandable: true,
  renderFooter: (data) => {
    return {
      left: `${data.rows.length} countermeasure${data.rows.length === 1 ? "" : "s"}`,
      right: null,
    };
  },
};

registerWidget(countermeasureTableDef);
